import { render, staticRenderFns } from "./cModalSubEspe.vue?vue&type=template&id=a672720c"
import script from "./cModalSubEspe.vue?vue&type=script&lang=js"
export * from "./cModalSubEspe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports